export let bannerListLabels = [
  {
    label: '序号',
    value: 'index'
  },
  {
    label: '广告位位置',
    value: 'name'
  },
  {
    label: '说明',
    minWidth: 150,
    value: 'extensionInfo.description'
  },
  {
    label: '尺寸（图片）',
    value: 'size'
  }
]
// 信息设置-信息类型枚举
export let setMessageType = [
  {
    label: '新闻',
    value: 'action'
  },
  {
    label: '商品',
    value: 'goods'
  },
  {
    label: '促销活动',
    value: 'promotion'
  },
  {
    label: '海报',
    value: 'poster'
  }
]
